import { F3WalkingSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { DAY_OPTIONS, TIME_OPTIONS, calculateMET } from "./helpers";

export default function Step4Walking({ dias, onDiasChange, tiempo, onTiempoChange, errors }) {
  const showTime = dias && dias !== "0";
  const met = calculateMET(3.3, dias, tiempo);
  const isUnsure = tiempo === "unsure";

  return (
    <div>
      <F3WalkingSVG />
      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        ¿Cuántos días caminaste al menos <strong>10 minutos seguidos</strong>? Incluye caminatas
        al trabajo, al mercado, por ejercicio o cualquier otra razón.
      </div>

      <PillSelect
        label="Días de caminata (últimos 7 días)"
        options={DAY_OPTIONS}
        value={dias}
        onChange={onDiasChange}
        error={errors?.getError("caminataDias")}
        testId="f3-walk-dias"
        columns={4}
      />

      {showTime && (
        <PillSelect
          label="Tiempo promedio por día"
          options={TIME_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
          value={tiempo}
          onChange={onTiempoChange}
          error={errors?.getError("caminataTiempo")}
          testId="f3-walk-tiempo"
          columns={1}
        />
      )}

      {showTime && tiempo && (
        <CalculatedBadge
          label="MET caminata/semana"
          value={isUnsure ? "—" : met ?? "—"}
          unit={isUnsure ? "" : "MET-min/sem"}
          category={isUnsure ? "No calculable" : null}
          categoryColor={isUnsure ? "#B5A998" : "#F9A01B"}
          testId="badge-met-caminata"
        />
      )}
    </div>
  );
}
